import { api } from 'utils/hooks/useApi';
import { get } from 'lodash';

export const archiveStudy = (studies: any): Promise<any> =>
  api()
    .post(`/portal-api/study/archive`, { studies })
    .then((response) => get(response, 'data'))
    .catch((error) => false);
